import {
  Activity,
  ClipboardList,
  FileText,
  HardDrive,
  LayoutDashboard,
  LogOut,
  Server,
  Shield,
  Timer,
  Users,
} from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { signOut } from '@/lib/auth'
import { cn } from '@/lib/utils'

const navItems = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/beta', label: 'Beta Waitlist', icon: ClipboardList },
  { to: '/users', label: 'Users', icon: Users },
]

const monitorItems = [
  { to: '/monitor', label: 'Monitor', icon: Activity },
  { to: '/monitor/requests', label: 'Requests', icon: FileText },
  { to: '/monitor/storage', label: 'Storage', icon: HardDrive },
]

const systemItems = [
  { to: '/system', label: 'System', icon: Server },
  { to: '/system/cron', label: 'Cron Log', icon: Timer },
]

export function Sidebar() {
  const handleSignOut = async () => {
    await signOut()
    window.location.href = '/login'
  }

  return (
    <aside className="fixed left-0 top-0 z-30 flex h-screen w-60 flex-col border-r border-dashed border-border bg-surface">
      <div className="flex items-center gap-2.5 border-b border-dashed border-border px-5 py-5">
        <Shield className="h-5 w-5 text-accent" strokeWidth={1.5} />
        <div>
          <p className="font-mono text-xs font-medium tracking-wider text-ink uppercase">
            LookBookIQ
          </p>
          <p className="font-mono text-[10px] tracking-widest text-ink-faint uppercase">Console</p>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto px-3 py-4">
        <ul className="space-y-1">
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-3 rounded-md px-3 py-2.5 font-mono text-xs transition-colors',
                    isActive
                      ? 'bg-accent/10 text-accent'
                      : 'text-ink-muted hover:bg-surface-alt hover:text-ink'
                  )
                }
              >
                <item.icon className="h-4 w-4" strokeWidth={1.5} />
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="my-3 border-t border-dashed border-border" />

        <p className="mb-2 px-3 font-mono text-[9px] tracking-widest text-ink-faint uppercase">
          Monitoring
        </p>
        <ul className="space-y-1">
          {monitorItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === '/monitor'}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-3 rounded-md px-3 py-2.5 font-mono text-xs transition-colors',
                    isActive
                      ? 'bg-accent/10 text-accent'
                      : 'text-ink-muted hover:bg-surface-alt hover:text-ink'
                  )
                }
              >
                <item.icon className="h-4 w-4" strokeWidth={1.5} />
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="my-3 border-t border-dashed border-border" />

        <p className="mb-2 px-3 font-mono text-[9px] tracking-widest text-ink-faint uppercase">
          System
        </p>
        <ul className="space-y-1">
          {systemItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === '/system'}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-3 rounded-md px-3 py-2.5 font-mono text-xs transition-colors',
                    isActive
                      ? 'bg-accent/10 text-accent'
                      : 'text-ink-muted hover:bg-surface-alt hover:text-ink'
                  )
                }
              >
                <item.icon className="h-4 w-4" strokeWidth={1.5} />
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <div className="border-t border-dashed border-border p-3">
        <button
          type="button"
          onClick={handleSignOut}
          className="flex w-full items-center gap-3 rounded-md px-3 py-2.5 font-mono text-xs text-ink-muted transition-colors hover:bg-surface-alt hover:text-negative"
        >
          <LogOut className="h-4 w-4" strokeWidth={1.5} />
          Sign Out
        </button>
      </div>
    </aside>
  )
}
